import axios from 'axios';
import { LearningCenterQueryData } from '../types';

const API_URL = '/api/v1/search/learningcenter'; // Same origin API endpoint

export const searchApi = async (query: string, parentId: string): Promise<LearningCenterQueryData> => {
    try {
        const params = {
            searchTerm: query,
            parentId: parentId
        };

        const response = await axios.get(API_URL, { params });

        return response.data.data;
    } catch (error) {
        return null;
    }
};
